/**
 * The seam between the fetch layer and app features that react to any API
 * response, such as the plan-limit upgrade dialog or cross-tab sync.
 *
 * `apiFetch` reports every response here, and the app entry registers what to
 * do about it (the customer app's `response-effects.ts`; admin registers
 * nothing). It lives in its own import-free module, like `unauthorized.ts`, so
 * `api.ts` stays the same in both front ends.
 */

type Listener = (res: Response, init: RequestInit | undefined) => void;

const listeners = new Set<Listener>();

/** Registers a listener; returns a function that removes it. */
export function onApiResponse(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Reports one backend response to every listener. */
export function reportApiResponse(res: Response, init: RequestInit | undefined): void {
  for (const listener of listeners) listener(res, init);
}
